var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongjinOH
 * @contact hjoh@detech.co.kr
 * @date 2023-04-20
 * @brief SEI 진단점검하기 step2 컴포넌트
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
// recoil
import { useRecoilState, useRecoilValue } from "recoil";
import { alertState, checkTypeState } from "../../../../../recoil/assessmentState";
import { userInfoLoginState } from "../../../../../recoil/userState";
// utils
import { langId } from "../../../../../recoil/langState";
import * as HTTPUTIL from "../../../../../utils/api/HttpUtil";
import * as CUTIL from "../../../../../utils/commUtils";
import * as CONST from "../../../../../utils/Const";
import { useTrans } from "../../../../../utils/langs/useTrans";
function CheckStep2() {
    const t = useTrans();
    // recoil
    const [check, setCheck] = useRecoilState(checkTypeState);
    const userInfo = useRecoilValue(userInfoLoginState);
    const [alert, setAlert] = useRecoilState(alertState);
    const langIds = useRecoilValue(langId);
    // useState
    const [checkSubTypeItem, setCheckSubtypeItem] = useState([]);
    const [checkVersionTypeItem, setCheckVersiontypeItem] = useState([]);
    const [errorList, setErrorList] = useState([]);
    // 상세유형 API
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/checksheet/checktype/${check.chekTypeInfo.checkTypeId}/checksubtypes`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: check.chekTypeInfo.checkTypeId.toString() + langIds,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setCheckSubtypeItem(data.body);
            }
        }
    }, [data, langIds]);
    // 버젼
    function CheckTypeVersion(type) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/checksheet/checktype/checksubtype/${type.checkSubTypeId}/checkversions`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setCheckVersiontypeItem(data.body);
                    setCheck(Object.assign(Object.assign({}, check), { chekSubTypeInfo: {
                            checkSubTypeId: type.checkSubTypeId,
                            checkSubName: type.checkSubName,
                        } }));
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    // 버젼선택
    function CheckTypeVersionSel(type) {
        return __awaiter(this, void 0, void 0, function* () {
            setErrorList(errorList.filter((err) => err.field !== "checkVersionId"));
            setCheck(Object.assign(Object.assign({}, check), { chekVersionTypeInfo: {
                    checkVersionId: type.checkVersionId,
                    versionNo: type.versionNo,
                } }));
        });
    }
    // 다음 step
    function NextStep(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (check.chekSubTypeInfo.checkSubTypeId > 0 && check.chekVersionTypeInfo.checkVersionId > 0) {
                setCheck(Object.assign(Object.assign({}, check), { nextStep: "step3", preStep: "step2" }));
            }
            else {
                setErrorList([
                    {
                        field: "checkVersionId",
                        msg: "상세유형 혹은 버젼을 선택하세요",
                    },
                ]);
            }
        });
    }
    // 이전 step
    function PreviousStep(e) {
        setCheck(Object.assign(Object.assign({}, check), { nextStep: "step1", chekTypeInfo: {
                checkTypeId: -1,
                checkTypeName: "",
            }, chekSubTypeInfo: {
                checkSubTypeId: -1,
                checkSubName: "",
            }, chekVersionTypeInfo: {
                checkVersionId: -1,
                versionNo: "",
            } }));
    }
    // 이전 이력
    function PreList(e) {
        e.preventDefault();
        setCheck(Object.assign(Object.assign({}, check), { nextStep: "prelist", preStep: "step2", chekSubTypeInfo: {
                checkSubTypeId: -1,
                checkSubName: "",
            }, chekVersionTypeInfo: {
                checkVersionId: -1,
                versionNo: "",
            } }));
    }
    return (_jsx(_Fragment, { children: _jsx("main", Object.assign({ className: "container" }, { children: _jsxs("section", Object.assign({ className: "content step2" }, { children: [_jsxs("div", Object.assign({ className: "top" }, { children: [_jsx("p", { children: "Step 2" }), _jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.상세유형/버전선택") }))] })), _jsxs("div", Object.assign({ className: "bottom" }, { children: [_jsxs("div", Object.assign({ className: "form-area" }, { children: [_jsx("button", Object.assign({ type: "button", className: "btn-back bg-white", onClick: (e) => PreviousStep(e) }, { children: _jsx("span", { children: check.chekTypeInfo.checkTypeName }) })), _jsxs("div", Object.assign({ className: "select subType", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: t("라벨.상세유형선택") })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: checkSubTypeItem &&
                                                    checkSubTypeItem.map((subCheck, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => CheckTypeVersion(subCheck) }, { children: subCheck.checkSubName }), "subCheck_" + idx.toString()))) })] })), _jsxs("div", Object.assign({ className: `select version ${errorList.filter((err) => err.field === "checkVersionId").length > 0 ? " input-error" : ""}`, onClick: (e) => check.chekSubTypeInfo.checkSubTypeId > 0 && CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: t("라벨.버전선텍") })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: checkVersionTypeItem &&
                                                    checkVersionTypeItem.map((type, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => CheckTypeVersionSel(type) }, { children: type.versionNo }), "verType_" + idx.toString()))) })] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "checkVersionId").map((err) => err.msg) }))] })), _jsx("a", Object.assign({ href: "#", onClick: (e) => PreList(e) }, { children: t("라벨.이전불러오기") })), _jsx("button", Object.assign({ type: "button", onClick: (e) => NextStep(e) }, { children: _jsx("span", { children: t("라벨.다음") }) }))] }))] })) })) }));
}
export default CheckStep2;
